module.exports = __webpack_public_path__ + "img/r1sf.1aa73a25.png";